import {get} from 'lodash';
import langSource from './LANG.json';

export abstract class Translation {

    public static get(propPath: string, fallBack?: string) {
        let source: any = langSource || {};
        if (!this.getLang()) {
            this.setLang('en')
        }

        const value: any = get(source, `${propPath}.${this.getLang()}`, null);
        if (value) {
            return value;
        } else if (fallBack) {
            return fallBack;
        } else {
            return '';
        }
    }

    /**
     * Nem a LANG.json-ból, hanem futásidőben betöltött tartalomból (API/JSON) választja ki
     * az aktuális nyelvű változatot. A várt alak ugyanaz a {en, hu} páros.
     */
    public static pick(source: any, fallBack: string = ''): string {
        if (!source) {
            return fallBack;
        }

        return source[this.getLang()] || source.en || source.hu || fallBack;
    }

    /*public static setSource(): Promise<any> {

        return new Promise((resolve) => {
            const currentSource = localStorage.getItem('LANG.source');
            const source = JSON.stringify(langSource);
            if (currentSource === source) {
                return resolve();
            }
            localStorage.setItem('LANG.source', source);
            return resolve();
        })
    }*/

    /* public static initLang() {
         const storedLang = localStorage.getItem('LANG');
         if (!storedLang) {
             localStorage.setItem('LANG', 'hu');
             LANG = 'hu';
         }
     }*/

    public static getLang() {
        const lang = localStorage.getItem('inteliart.hu.LANG');
        if (lang) {
            return lang;
        } else {
            return 'en';
        }
    }

    public static setLang(lang: string) {
        if (lang === this.getLang()) {
            return;
        }
        localStorage.setItem('inteliart.hu.LANG', lang);
        location.reload();
    }
}
